import { Component, OnInit, Input } from '@angular/core';
import { LocalStorageService } from '../../../services/local-storage.service';
import { GemsService } from 'client/app/shared/services';
import { each, filter, some } from 'lodash';

const globalAlertsId = 'alerts_global';
const pageAlertsId = 'alerts_page';
const validAlertTypes = ['information', 'success', 'marketing', 'error', 'default'];

@Component({
  selector: 'app-dismissible-alert',
  templateUrl: 'dismissible-alert.component.html',
  styleUrls: ['dismissible-alert.component.less'],
  standalone: false
})
export class DismissibleAlertComponent implements OnInit {

  @Input() pageId: any;
  @Input() helpTextAliases: any;
  @Input() isGlobal: any;
  hasAlerts: boolean = false;
  alerts: any = [];

  constructor(
    private gemsService: GemsService
  ) { }

  ngOnInit() {
    this.loadContent();
  }

  closeAlert(alert: any) {
    this.markAlertDismissed(alert);
  };

  updateAndFilterAlerts(contents) {
    // add calculated fields
    each(contents, (al: any) => {

      al.showLink = al.linktext && al.linkurl;
      al.showAlert = this.shouldAlertBeDisplayed(al);
    });

    return filter(contents, (al: any) => {
      return al.showAlert;
    });
  }

  shouldAlertBeDisplayed(al: any) {
    // first check for valid alert types
    const isValid = some(validAlertTypes, (type) => {
      return type === al.type;
    });
    let retval = isValid;

    if (isValid) {
      // check local storage
      const key = this.getAlertKey(al);
      const data = LocalStorageService.fetch(key);
      retval = !data;
    }
    return retval;
  }

  markAlertDismissed(al: any) {

    if (!al.dismissible) {
      throw new Error('Alert is not dismissible!');
    }
    // check local storage
    const key = this.getAlertKey(al);
    LocalStorageService.stash(key, true);
    al.showAlert = false;
  }

  getAlertKey(al: any) {
    return al.nodeid + '_' + al.updated;
  }

  loadContent() {

    this.gemsService.loadContent(this.pageId, this.helpTextAliases).subscribe((content: any) => {

      if (content) {
        const contentId = (this.isGlobal)
          ? globalAlertsId
          : pageAlertsId;

        const alertContents = filter(content.contents, (ct: any) => {
          return ct.contentid === contentId;
        });
        if (!alertContents || alertContents.length < 1) {
          this.hasAlerts = false;
        }
        else {
          let alerts = alertContents && alertContents[0] && alertContents[0].contents;

          alerts = this.updateAndFilterAlerts(alerts);

          this.alerts = alerts;
          this.hasAlerts = (alerts && alerts.length);
        }
      }
    }, (error) => {
      console.log(error)
    });
  }
}


